export default function Accordion() {
  const accItemToggle = $('.c-accordion-item__header')
  const accItemButton = $('.c-accordion-item__button')

  const closeAccordionItems = () => {
    const openAccItemToggles = $('.c-accordion-item__header.active')
    openAccItemToggles.each(function () {
      const expandedHeader = $(this)
      expandedHeader.siblings('.c-accordion__content').slideUp(200)
      expandedHeader.removeClass('active')
      expandedHeader.find('.c-accordion-item__button').attr('aria-expanded', 'false')
    })
  }

  const init = () => {
    accItemToggle.on('click', function () {
      const t = $(this)
      if (t.hasClass('active')) {
        closeAccordionItems()
      } else {
        closeAccordionItems()
        t.siblings('.c-accordion__content').slideToggle(200)
        t.toggleClass('active')
        t.find('.c-accordion-item__button').attr('aria-expanded', 'true')
      }
    })

    accItemButton.on('focus', function () {
      $(this).closest('.c-accordion-item').addClass('in-focus')
    })

    accItemButton.on('blur', function () {
      $(this).closest('.c-accordion-item').removeClass('in-focus')
    })
  }

  return {
    init: init,
  }
}
